<template>
  <v-container fluid :class="{'px-0': $vuetify.breakpoint. smAndDown}">
          
    <v-layout xs12 v-if="!$store.getters.docid">
      <v-flex sm3 class="ml-5 hidden-sm-and-down embedContainer" v-if="getFile">
        <object :data="getFile+'#toolbar=0&navpanes=0&scrollbar=0'" type="application/pdf" width="100%" height="100%"
        v-if="getFile && typeOfFile == 'application/pdf'"
        ></object>
        <img :src="getFile" alt="" style="width:100%"
        v-else-if="getFile && typeOfFile.startsWith('image')"
        >
        <img src="@/assets/unknown.png" alt="" style="width:100%"
        v-else
        >
        <div class="text-block"> 
          <h4>{{ fileName }}</h4>
        </div>
      </v-flex>

      <v-spacer class="hidden-sm-and-down"></v-spacer>
      <v-flex sm12 md8>
        <v-card class="mx-5: $vuetify.breakpoint. mdAndUp">
          <v-flex xs12>
            <v-textarea
              value="Результаты расчёты цифрового отпечатка"
              auto-grow
              solo
              hide-details
              rows='1'
              disabled
              outlined
              :class="{'l-font': $vuetify.breakpoint. smAndDown, 'b-font': $vuetify.breakpoint. mdAndUp}"
              class="centered-input px-2"
              style="text-align: center; color: black; line-height: 2rem"
            ></v-textarea>
          </v-flex>
          <v-flex v-if="calculated">
            <!-- Посчитали -->
            <v-layout xs12 class="pt-5 flexcenter mx-1"> 
              <v-flex xs3>
                <v-text-field
                value="MD5"
                single-line
                solo
                hide-details
                disabled
                flat
                :class="{'l-font': $vuetify.breakpoint. smAndDown}"
                class="px-2 blacktext"
                ></v-text-field>
              </v-flex>
              <v-flex xs8 @click.stop="opendialog('MD5', md5value)">
                <v-text-field
                :value="md5value"
                single-line
                solo
                hide-details
                readonly
                outlined
                class="px-2 blacktext truncated"
                :class="{'l-font': $vuetify.breakpoint. smAndDown}"
                ></v-text-field>
              </v-flex>
              <v-flex xs1>
                <v-btn tile large icon class="icon-btn"
                  v-clipboard="md5value"
                  v-clipboard:success="clipboardSuccessHandler"
                  v-clipboard:error="clipboardErrorHandler"
                >
                  <img src="@/assets/copypaste.png" alt="" style="width:90%">
                </v-btn>
              </v-flex>
            </v-layout>

            <v-layout xs12 class="flexcenter mx-1"> 
              <v-flex xs3>
                <v-text-field
                value="SHA-3"
                single-line
                solo
                hide-details
                disabled
                flat
                class="px-2 blacktext"
                :class="{'l-font': $vuetify.breakpoint. smAndDown}"
                ></v-text-field>
              </v-flex>
              <v-flex xs8 @click.stop="opendialog('SHA-3', sha3value)">
                <v-text-field
                :value="sha3value"
                single-line
                solo
                hide-details
                readonly
                outlined
                class="px-2 blacktext truncated"
                :class="{'l-font': $vuetify.breakpoint. smAndDown}"
                ></v-text-field>
              </v-flex>
              <v-flex xs1>
                <v-btn tile large icon class="icon-btn"
                  v-clipboard="sha3value"
                  v-clipboard:success="clipboardSuccessHandler"
                  v-clipboard:error="clipboardErrorHandler"
                >
                  <!-- <v-icon>mdi-vuetify</v-icon> -->
                  <img src="@/assets/copypaste.png" alt="" style="width:90%">
                </v-btn>
              </v-flex>
            </v-layout>

            <v-layout xs12 class="flexcenter mx-1"> 
              <v-flex xs3>
                <v-text-field
                value="SHA512"
                single-line
                solo
                hide-details
                disabled
                flat
                class="px-2 blacktext"
                :class="{'l-font': $vuetify.breakpoint. smAndDown}"
                ></v-text-field>
              </v-flex>
              <v-flex xs8 @click.stop="opendialog('SHA512', sha512value)">
                <v-text-field
                :value="sha512value"
                single-line
                solo
                hide-details
                readonly
                outlined
                class="px-2 blacktext truncated"
                :class="{'l-font': $vuetify.breakpoint. smAndDown}"
                ></v-text-field>
              </v-flex>
              <v-flex xs1>
                <v-btn tile large icon class="icon-btn"
                  v-clipboard="sha512value"
                  v-clipboard:success="clipboardSuccessHandler"
                  v-clipboard:error="clipboardErrorHandler"
                  >
                  <!-- <v-icon>mdi-vuetify</v-icon> -->
                  <img src="@/assets/copypaste.png" alt="" style="width:90%">
                </v-btn>
              </v-flex>
            </v-layout>

          </v-flex>

          <v-flex v-else class="py-5 flexcenter">
            <!-- Еще считаем   -->
            <v-progress-circular
              align-self-center
              :size="80"
              :width="7"
              color="grey"
              indeterminate
                          style="margin: 4rem auto"

            ></v-progress-circular>          
          </v-flex>        
        </v-card>
      </v-flex>
    </v-layout>

    <v-layout xs12 class="pt-5" v-if="registered">
      <v-flex xs12>
        <v-card class="mx-5: $vuetify.breakpoint. mdAndUp">
          <v-flex xs12>
              <v-textarea
                :value="headerText"
                auto-grow
                solo
                hide-details
                rows='1'
                disabled
                outlined
                class="centered-input px-2"
                :class="{'l-font': $vuetify.breakpoint. smAndDown, 'b-font': $vuetify.breakpoint. mdAndUp}"
                style="text-align: center; color: black"
              ></v-textarea>
            </v-flex>
            <v-flex v-if="calculated">
              <!-- Посчитали -->
              <v-layout xs12 class="pt-5 flexcenter mx-1 py-1"> 
                <v-flex xs4>
                  <v-text-field
                  value="ID-файла"
                  single-line
                  solo
                  hide-details
                  disabled
                  flat
                  class="px-2 blacktext"
                  :class="{'l-font': $vuetify.breakpoint. smAndDown}"
                  ></v-text-field>
                </v-flex>
                <v-flex xs8 @click.stop="opendialog('ID-файла', documentID)">
                  <v-text-field
                  :value="documentID"
                  single-line
                  solo
                  hide-details
                  disabled
                  outlined
                  class="px-2 blacktext truncated"
                  :class="{ 'greenbg': foundedDoc, 'redbg': !foundedDoc, 'l-font': $vuetify.breakpoint. smAndDown }"
                  ></v-text-field>
                </v-flex>
              </v-layout>

              <v-layout xs12 class="flexcenter mx-1 py-1"> 
                <v-flex xs4>
                  <v-text-field
                  value="Система-регистратор"
                  single-line
                  solo
                  hide-details
                  disabled
                  flat
                  class="px-2 blacktext"
                  :class="{'l-font': $vuetify.breakpoint. smAndDown}"
                  ></v-text-field>
                </v-flex>
                <v-flex xs8 @click.stop="opendialog('Система-регистратор', registrator)">
                  <v-text-field
                  :value="registrator"
                  single-line
                  solo
                  hide-details
                  disabled
                  outlined
                  class="px-2 blacktext truncated"
                  :class="{ 'greenbg': foundedDoc, 'redbg': !foundedDoc, 'l-font': $vuetify.breakpoint. smAndDown }"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-flex>

            <v-flex v-else class="py-5 flexcenter">
              <!-- Еще считаем   -->
              <v-progress-circular
                align-self-center
                :size="80"
                :width="7"
                color="grey"
                indeterminate
                style="margin: 4rem auto"
              ></v-progress-circular>          
            </v-flex>        
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout xs12 class="pt-5" v-else>
      <v-row>
        <v-col cols="6">
          <v-form v-model="emailIsValid">
          <v-text-field
            hide-details
            label="E-mail для получения отчета о регистрации"
            auto-grow
            outlined
            rows="1"
            row-height="15"
            v-model="email"
            :rules="[rules.required, rules.email]"
        ></v-text-field>
          </v-form>
        </v-col>
        <v-col cols="12">
        <component :is="documentRegistration"
          :registrationData="registrationData"
          @registration-failed="onRegistrationFailed"
          :disabled="!toRegister || !emailIsValid"
          @start-loading="() => isLoading = true"
          @finish-loading="() => isLoading = false"
        />
        </v-col>
      </v-row>
    </v-layout>
    <DemoLabel/>
    <v-dialog
      v-model="dialog"
      max-width="290"
    >
      <v-card>
        <v-card-title class="headline">{{ dialigHeader }}</v-card-title>

        <v-card-text style="word-break: break-word;">
          {{ dialogText }}
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            @click="dialog = false"
          >
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
    
    <v-snackbar
      v-model="snackbar"
      :timeout="timeout"
      :color="snackbarColor"
    >
      {{ snackbarText }}
      <v-btn text icon @click="snackbar = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
    <v-overlay :value="isLoading">
      <v-progress-circular
        align-self-center
        :size="80"
        :width="7"
        color="grey"
        indeterminate
        style="margin: 4rem auto"
      ></v-progress-circular>          
    </v-overlay>
  </v-container>
  
</template>

<script>
import CryptoJS from 'crypto-js'
import { v4 as uuid } from 'uuid'
import { isDemo } from '../environment'
import DemoLabel from './DemoLabel.vue'
import DocumentRequestrationForm from './DocumentRequestrationForm.vue'
import DemoDocumentRegistrationForm from './DemoDocumentRegistrationForm.vue'
import { usePathFromBaseURI, useQuery } from '../infrastructure/api/endpoints'
import { httpClient } from '../infrastructure/api/config'

const patternEmail = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;


export default {
  components: {
    DemoLabel,
    DemoDocumentRegistrationForm,
    DocumentRequestrationForm
},

  data() {
    return {
      isLoading: false,
      calculated: false,
      md5value: '',
      sha3value: '',
      sha512value: '',
      documentID:'',
      registrator:'',
      status:'',
      dialog: false,
      dialigHeader: '',
      dialogText: '',
      typeOfFile: '',
      fileName: '',
      snackbarText: '',
      snackbar: false,
      timeout: 1000,
      snackbarColor: undefined,
      foundedDoc: false,
      headerText: 'Файл уже зарегистрирован в системе AVISHASH',
      registered: false,
      toRegister: false,
      email: null,
      emailIsValid: false,
      rules: {
        required: v => !!v || "Обязательное поле",
        email: v => patternEmail.test(v) || "Неверный адрес E-mail"
      },
      orderNumber: null,
    }
  },
  computed: {
    getFile() {
      if (this.$store.getters.file) {
        return window.URL.createObjectURL(this.$store.getters.file)
      }
      return null
    },
    documentRegistration() {
      return isDemo() ? DemoDocumentRegistrationForm : DocumentRequestrationForm
    },
    registrationData() {
      return {
        DocID: this.orderNumber,
        MD5Hash: this.md5value,
        SHA512Hash: this.sha512value,
        SHA3512Hash: this.sha3value,
        email: this.email,
        fileName: this.fileName
      }
    },
  },
  methods: {
    onRegistrationFailed() {
      this.snackbarColor = 'error'
      this.snackbarText = 'Ошибка создания транзакции'
      this.snackbar = true
    },
    opendialog(header, text) {
      this.dialigHeader = header
      this.dialogText = text
      this.dialog = true
    },
    clipboardSuccessHandler () {
      this.snackbarColor = undefined
      this.snackbarText = 'Скопировано'
      this.snackbar = true
    },

    clipboardErrorHandler () {
      this.snackbarColor = 'error'
      this.snackbarText = 'Ошибка копирования'
      this.snackbar = true
    },
    onFileSelect(file){
      var reader = new FileReader();
      let self = this
      reader.addEventListener('load',function () {
        self.md5value = CryptoJS.MD5(CryptoJS.enc.Latin1.parse(this.result)).toString(CryptoJS.enc.Hex)
        self.sha3value = CryptoJS.SHA3(CryptoJS.enc.Latin1.parse(this.result)).toString(CryptoJS.enc.Hex)
        self.sha512value = CryptoJS.SHA512(CryptoJS.enc.Latin1.parse(this.result)).toString(CryptoJS.enc.Hex)

        // let requestURL = `/check?md5=${self.md5value}&sha_512=${self.sha512value}&sha3_512=${self.sha3value}&docId=null`
        httpClient
          .get(
            useQuery(() => usePathFromBaseURI('DocumentStamps', 'check'), { name: 'md5', value: self.md5value }, { name: 'sha_512', value: self.sha512value },
              { name: 'sha3_512', value: self.sha3value }, { name: 'docId', value: 'null' }).href, {
              headers: {
                'Access-Control-Allow-Origin': 'cors',
              },
            }
          )
          .then(response => {
            self.registered = true
            self.documentID = response.data.DocID
            self.registrator = response.data.ServiceName
            self.status = 'Целостность не нарушена'
            self.foundedDoc = true
            self.calculated = true
          })
          .catch(() => {
            self.toRegister = true
            self.documentID = ''
            self.registrator = ''
            self.status = 'Файл не найден'
            self.foundedDoc = false
            self.calculated = true
          });
      })

       reader.readAsBinaryString(file);
    },
  },
  mounted() {
    if (!this.$store.getters.file && !this.$store.getters.docid) {
      this.$router.push('/registration')
    } else if (this.$store.getters.docid) {
      this.checkById(this.$store.getters.docid)
    } else {
      this.typeOfFile = this.$store.getters.file.type
      this.fileName = this.$store.getters.file.name
      this.onFileSelect(this.$store.getters.file)
    }
    this.orderNumber = uuid()
  }
}
</script>

<style>
  .centered-input input {
    text-align: center;
    color:black !important
  }
  .centered-input textarea {
    text-align: center;
    color:black !important;
    margin:1rem auto;
    line-height: 100%;
  }
  .icon-btn .v-btn__content {
    width: 90%;
  }
  .flexcenter {
    justify-content: center; align-items: center; display: flex;
  }

  .blacktext input {
    color: black !important;
  }

  .greenbg fieldset{
    background-color: #c5f3c5a8
  }
  .redbg fieldset{
    background-color: #ff673c96
  }

  .l-font textarea{
    font-size: 0.8rem;
  }
  .b-font textarea{
    font-size: 1.5vw;
  }
  .l-font input{
    font-size: 0.8rem;
  }
  .b-font input{
    font-size: 1.5vw;
  }
  .embedContainer {
    position: relative;
  }
  .text-block {
    position: absolute;
    bottom: 0.1rem;
    margin-left: auto;
    margin-right: auto;
    left: 0;
    right: 0;
    background-color: #2d2d2dc7;
    color: #fafafa;
    padding-left: 20px;
    padding-right: 20px;
    text-align: center;
  }
  .truncated input {
    text-overflow: ellipsis;
  }
  #submitbutton .v-btn__content {
    width: fit-content;
  }

</style>